export const dummyUsers = {
    "totalPages": 1,
    "totalElements": 4,
    "elements": [
        {
            "id": 3,
            "username": "maria",
            "name": "test_user",
            "password": null,
            "userRole": "ROLE_SUPER_ADMIN",
            "lastLoginTs": "2019-07-08",
            "status": "active",
            "accountDomainUrl": "elb.kanin.io"
        },
        {
            "id": 4,
            "username": "lyubo",
            "name": "test_user",
            "password": null,
            "userRole": "ROLE_ADMIN",
            "lastLoginTs": "2019-03-25",
            "status": "active",
            "accountDomainUrl": "elb.kanin.io"
        },
        {
            "id": 6,
            "username": "bozhidar.marinov@sirma.bg",
            "name": "test_user",
            "password": null,
            "userRole": "ROLE_ADMIN",
            "lastLoginTs": null,
            "status": "active",
            "accountDomainUrl": "elb.kanin.io"
        },
        {
            "id": 5,
            "username": "admin3",
            "name": "test_user",
            "password": null,
            "userRole": "ROLE_EDITOR",
            "lastLoginTs": "2018-12-17",
            "status": "active",
            "accountDomainUrl": "elb.kanin.io"
        }
    ]
};

export const filterObj = {
    "pageNumber": 1,
    "pageSize": 10,
    "sort": {
        "name": "ASC"
    },
    "filters": null
};

export const columns = [
    { name: 'username', title: 'User' },
    { name: 'name', title: 'Name' },
    { name: 'lastLoginTs', title: 'Last seen on site' },
    { name: 'status', title: 'Status' },
    { name: 'userRole', title: 'Role' },
    { name: 'actions', title: 'Actions' },
    //{ name: '', title: '' }
];

export const pageSizes = [5, 10, 15];

export const tableColumnFiltering = [
    { columnName: 'lastLoginTs', filteringEnabled: false },
    { columnName: 'actions', filteringEnabled: false },
    //{ columnName: '', filteringEnabled: false }
];


// WEBPACK FOOTER //
// ./src/main/content/user-management/user-management-util.js